import "../../node_modules/van11y-accessible-accordion-aria/dist/van11y-accessible-accordion-aria.js";
